import { formatDateStr } from '../../utils/DateUtil';

export default function BlogDetailSummary({ postCount, accessCount, latestPublishedAt, collectedAt }) {
    const latestPublishedAtFormatted = formatDateStr(latestPublishedAt);
    const collectedAtFormatted = formatDateStr(collectedAt);

    return (
        <div className="redesign-detail-panel">
            <div className="redesign-blog-stats">
                <div>
                    <div className="redesign-blog-stat-label">文章收录</div>
                    <div className="redesign-blog-stat-value">{postCount}</div>
                </div>
                <div>
                    <div className="redesign-blog-stat-label">文章浏览</div>
                    <div className="redesign-blog-stat-value">{accessCount}</div>
                </div>
                <div>
                    <div className="redesign-blog-stat-label">最近更新</div>
                    <div className="redesign-blog-stat-value">{latestPublishedAtFormatted}</div>
                </div>
                <div>
                    <div className="redesign-blog-stat-label">收录时间</div>
                    <div className="redesign-blog-stat-value">{collectedAtFormatted}</div>
                </div>
            </div>
        </div>
    );
}